// IE 2026 09 12 / ODOO-335246 (Igor): узел-квадрат для задач графа каскада — та же программа, что точка sigma (1 вершина,
// gl.POINTS), но фрагментный шейдер режет по расстоянию Чебышёва (квадрат), а не по радиусу (круг). Регистрируется как
// nodeProgramClasses.square; бэк ставит attributes.type = 'square' узлам задач. Без внешнего пакета @sigma/node-square.
import { NodePointProgram } from "sigma/rendering"

const FRAGMENT_SHADER_SOURCE = /* glsl */ `
precision mediump float;

varying vec4 v_color;
varying float v_border;

const float radius = 0.5;
const vec4 transparent = vec4(0.0, 0.0, 0.0, 0.0);

void main(void) {
  vec2 m = gl_PointCoord - vec2(0.5, 0.5);
  // скруглённый квадрат (SDF rounded box): радиус скругления 24% полустороны — как у виджетов
  const float rr = 0.12;
  vec2 q = abs(m) - vec2(radius - rr);
  float dist = rr - (length(max(q, 0.0)) + min(max(q.x, q.y), 0.0));

  #ifdef PICKING_MODE
  if (dist > v_border)
    gl_FragColor = v_color;
  else
    gl_FragColor = transparent;
  #else
  float t = 0.0;
  if (dist > v_border)
    t = 1.0;
  else if (dist > 0.0)
    t = dist / v_border;

  gl_FragColor = mix(transparent, v_color, t);
  #endif
}
`

export default class NodeSquareProgram extends NodePointProgram {
    getDefinition() {
        return { ...super.getDefinition(), FRAGMENT_SHADER_SOURCE }
    }
}
